/** Shopify CDN: Minification failed

Line 54:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 86:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 92:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 104:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 111:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 123:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 167:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 199:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 206:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 218:0 Transforming let to the configured target environment ("es5") is not supported yet
... and 21 more hidden warnings

**/
/* Custom JS */

/*Slideup minicart*/
$(document).on('click', ".minicart-up", function() {
  jQuery('.mini-cart').slideUp('slow'); 
})
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
     //>=, not <=
    if (scroll >= 200) {
        //clearHeader, not clearheader - caps H
        $("body").addClass("stick__bar");
    }
    else { $("body").removeClass("stick__bar"); }
});
jQuery(document).ready(function(){
  
if ('visited' === localStorage.getItem('popup_set')) {
  $('body').addClass('visited');
  $(".popup__wrapper").removeClass("show_new_popup");
}else {
  $('body').removeClass('visited');
  $(".popup__wrapper").addClass("show_new_popup");
}  
  
$(".cart--btn").on("click", function(e) {
    e.preventDefault();
    $(".add-cart-list--wrapper").toggleClass("cart--open");
    e.stopPropagation()
});
$(document).on("click", function(e) {
    if ($(e.target).is(".add-cart-list--wrapper, .cart_wrapper") === false) {
      $(".add-cart-list--wrapper").removeClass("cart--open");
    }
});
$(".add-cart-list--wrapper").on("click", function(event) { event.stopPropagation(); });
  
/*Slider 1*/
let PartnerSection = $('.partner--section').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    adaptiveHeight: true,
    autoplay: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed: 5000,
    infinite: false,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});
let partner_sectiondots = $('.slick-dots > li', PartnerSection);
PartnerSection.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  $(partner_sectiondots[nextSlide]).nextAll().removeClass('past');
  $(partner_sectiondots[nextSlide]).prevAll().addClass('past');
});
/*Slider 2*/
let mySlider2 = $('.slider1').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      adaptiveHeight: true,
      autoplay: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      autoplaySpeed: 5000,
      infinite: false,
    });
    let dots2 = $('.slick-dots > li', mySlider2);
    mySlider2.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      $(dots2[nextSlide]).nextAll().removeClass('past');
      $(dots2[nextSlide]).prevAll().addClass('past');
    });
  
/*Slider 3*/
let mySlider3 = $('.slider2').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  adaptiveHeight: true,
  autoplay: false,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 5000,
  infinite: false,
});
let dots3 = $('.slick-dots > li', mySlider3);
mySlider3.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  $(dots3[nextSlide]).nextAll().removeClass('past');
  $(dots3[nextSlide]).prevAll().addClass('past');
});
/*Slider 4*//*
let mySlider4 = $('.slider3').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  adaptiveHeight: true,
  autoplay: false,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 5000,
  infinite: false,
  responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});
let dots4 = $('.slick-dots > li', mySlider4);
mySlider4.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $(dots4[nextSlide]).nextAll().removeClass('past');
    $(dots4[nextSlide]).prevAll().addClass('past');
});
*/
let Slider3 = $('.slider3').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    adaptiveHeight: true,
    autoplay: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed: 5000,
    infinite: false,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});
let Slider3dots = $('.slick-dots > li', Slider3);
Slider3.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  $(Slider3dots[nextSlide]).nextAll().removeClass('past');
  $(Slider3dots[nextSlide]).prevAll().addClass('past');
});


let ourteam = $('.OurTeam').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    adaptiveHeight: true,
    autoplay: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed: 5000,
    infinite: false,
});
let ourteamdots = $('.slick-dots > li', ourteam);
ourteam.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $(ourteamdots[nextSlide]).nextAll().removeClass('past');
    $(ourteamdots[nextSlide]).prevAll().addClass('past');
});  

$('.testimonial-wrap').slick({
    xslidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    adaptiveHeight: true,
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed: 5000,
    infinite: true,
});
  
/* -- Popup JS -- */
  $(".popup__1 .g__text a").on("click", function(e){
        e.preventDefault();
        $(".popup__wrapper").addClass("show_new_popup");
    });
  $(".popup__close__btn").on("click", function(e){
    e.preventDefault();
    localStorage.setItem('popup_set', 'visited');
    $('body').addClass('visited');
    $(".popup__wrapper").removeClass("show_new_popup");
  });
  
    
  var checkAvailable = (function(){

    let _items = {};
    let _province = '';
    let _variant_ids = [];
    let _product_ids = [];
    let _url = 'https://apiv2.goodmeal.com.au/inventory/check';
    //let _url = 'https://goodmeal.draftserver.com/inventory/check';
    let _hasError = false;
    let _inventory_levels = {};

    let _postcodefield = jQuery('#cpostcode_input');
    let _submit = $('button.postcode__submit');
    let _btn_group = $('form.cart .input-group span.input-group__btn');
    let _suggestions = $(".suggestions");

    //Init
    async function init(location){
      _hasError = false;

      //Set Province base on the location
      setProvince(location);

      //Get cart items
      await getCartItems();

      //Check Inventory Availability

      //Todo - add back
      await checkInventoryAvailability();

      //Update cart
      
      //Todo - add back
      updateCartInventoryAvailablity(_inventory_levels);

      return Promise.resolve(_hasError);
    }

    //Return Province Code from given address.  
    function setProvince(_location){
      _location = _location.split(",");
      if(typeof _location[0] !== 'undefined') {
        _location = _location[0].split(' ');
        _province = _location[_location.length-1];
      }
    }

    //Cart information
    function getCartItems(){
      return jQuery.getJSON('/cart.js', function(cart) {
        if(cart.item_count > 1){
          _items = cart.items;
          _variant_ids = [];
          _product_ids = [];
          cart.items.forEach(function(item, i){
            //console.log(item);
            _variant_ids.push(item.variant_id);
            _product_ids.push(item.product_id);
          });
        }
      });
    }

    //Check Inventory through API in shopify
    function checkInventoryAvailability() {
      //SA, VIC, QLD, TAS and ACT warehouse stock check in NSW warehouse since NSW warehouse will delivery to those regions
      _province = (_province == 'SA' || _province == 'VIC' || _province == 'QLD' || _province == 'TAS' || _province == 'ACT' ) ? 'NSW' : _province;
      return jQuery.ajax({
        method:'GET',
        url: _url,
        crossDomain: true,
        async:true,
        dataType: 'json',
        data:{ variant_ids: _variant_ids.toString(), product_ids: _product_ids.toString(), province_code: _province, shop: 'goodmeal' },
        beforeSend: function(){
          _postcodefield.addClass('ui-autocomplete-loading').prop('disabled', true);
        },
        success: function(data){
          _inventory_levels = data;
        },
        complete: function(data) { 
          _postcodefield.removeClass('ui-autocomplete-loading').prop('disabled', false);
        }
      });
    }

    window.getPublicHolidaysFromShopify = function(){
        var public_holiday = ["2024/01/01","2024/01/02","2024/24/01","2024/25/02", "2024/04/30", "2024/04/27"];//["2017/04/28","2017/05/03"];
        return public_holiday; 
    }

    //Update in cart page
    function updateCartInventoryAvailablity(data){

      let _delivery_productid = 1421586137139;
      let _html = '<p style="color:red;">You cannot proceed until the following items are removed:<br></p>' + '<ul>';

      //Cart items
      _items.forEach(function(item, i){
        let isExist = false;

        //skip if delivery product
        if(_delivery_productid == item.product_id) {
          return;
        }

        //Available inventory items
        data.inventory_levels.forEach(function(itm, j){
          if(itm.product_id == item.product_id){
            isExist = true;
            if(itm.available !== null && itm.available < item.quantity) {
              _hasError = true;
              console.log(itm);
              _html += '<li><strong>' + item.product_title + '</strong> is currently out of stock.</li>';            
            }
          }
        });

        if(!isExist && data.inventory_levels.length < 50){ //limit to 50 items from Shopify API, for bulk orders with more than 50 SKU 
          console.log(i);
          _hasError = true;
          _html += '<li><strong>' + item.product_title + '</strong> is currently not available.</li>';
        }

      });
      _html += '</ul>';

      if(_hasError){
        _submit.prop('disabled', true);
        _btn_group.addClass('notallowed');
        _suggestions.html(_html);
        cartpostcoderesponse(false);
      }
    }

    return {
      init: init,
    };

  })();

  var day;
  /* Postcode check */
  	//postcode check from cart page
    jQuery('button.cart-postcode-check').click(function(){
      var j = jQuery(this);
      var cwrapper = j.parent().parent();
      var inputval = cwrapper.find('#cpostcode_input').val();
      var resultfield = cwrapper.parent().find('.cpostcoderesult');
      var checkplace = 'cart';
      checkpostcoderesult(inputval,resultfield,checkplace);
    });                                     
    jQuery('.checkpostcodeform').submit(function(e){
      e.preventDefault();
      var j = jQuery(this);
      var postinput = j.find('#postcode_input');
      var inputval = postinput.val();
      var resultfield = j.find('.postcoderesult');
      var checkplace = '';
      checkpostcoderesult(inputval,resultfield,checkplace);
    });
    function checkpostcoderesult(inputval, resultfield, checkplace){
      postcodelist.wronginput = "Invalid postcode";
      if(inputval.length){
        if(inputval.length !== 4){
          resultfield.removeClass('failed success').text('');
          resultfield.addClass('failed').text(postcodelist.wronginput);
          if(checkplace=='cart'){cartpostcoderesponse(false);}
        }else{
          resultfield.removeClass('failed success').text('');

          if($.inArray(inputval, postcodelist.postcodes) > -1){
              //common success message
              var successmsg = postcodelist.successmsg;

              if($.inArray(inputval, postcodelist.sydneypostcode) > -1){
                successmsg = postcodelist.sydneymsg;
              }else if($.inArray(inputval, postcodelist.melbournepostcode) > -1){
                successmsg = postcodelist.melbournemsg;
              }else if($.inArray(inputval, postcodelist.adelaidepostcode) > -1){
                successmsg = postcodelist.adelaidemsg;
              }else if($.inArray(inputval, postcodelist.brisbanenorthpostcode) > -1){
                successmsg = postcodelist.brisbanenorthmsg;
              }else if($.inArray(inputval, postcodelist.brisbanesouthpostcode) > -1){
                successmsg = postcodelist.brisbanesouthmsg;
              }else if($.inArray(inputval, postcodelist.goldcoastpostcode) > -1){
                successmsg = postcodelist.goldcoastmsg;
              }else if($.inArray(inputval, postcodelist.sunshinecoastpostcode) > -1){
                successmsg = postcodelist.sunshinecoastmsg;
              }
              resultfield.addClass('success').text(successmsg);
              if(checkplace=='cart'){cartpostcoderesponse(true);}
            }else{
              resultfield.removeClass('failed success').text('');
              resultfield.addClass('failed').text(postcodelist.failedmsg);
              if(checkplace=='cart'){cartpostcoderesponse(false);}
            }
          }
        }else{
          resultfield.removeClass('failed success').text('');
          resultfield.addClass('failed').text('Please input postcode');
          if(checkplace=='cart'){cartpostcoderesponse(false);}
        }
      //checkoutbuttonstatus();
    }

    /* End of Postcode check */

    /* Quantity plus minus js */

    // This button will increment the value
    jQuery(document).on("click",".qtyplus",function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($(this).parent().find('input[name='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            var new_val = currentVal + 1;
            $(this).parent().find('input[name='+fieldName+']').val(new_val);
            $(this).parent().find('input[name='+fieldName+']').attr('value',new_val);
          } else {
            // Otherwise put a 0 there
            $(this).parent().find('input[name='+fieldName+']').val(1);
            $(this).parent().find('input[name='+fieldName+']').attr('value',new_val);
          }
        });
    // This button will decrement the value till 0Before 7am
    jQuery(document).on("click",".qtyminus",function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($(this).parent().find('input[name='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 1) {
            // Decrement one
            var new_val = currentVal - 1;
            $(this).parent().find('input[name='+fieldName+']').val(new_val);
            $(this).parent().find('input[name='+fieldName+']').attr('value',new_val);
          } else {
            // Otherwise put a 0 there
            $(this).parent().find('input[name='+fieldName+']').val(1);
            $(this).parent().find('input[name='+fieldName+']').attr('value',1);
          }
        });
    jQuery(".product-extra-info .tabs-menu a").click(function(event) {
      event.preventDefault();
      jQuery(this).parent().addClass("current");
      jQuery(this).parent().siblings().removeClass("current");
      var tab = $(this).attr("href");
      jQuery(".tab-content").not(tab).css("display", "none");
      jQuery(tab).css('display','block');
    });
  	//prevent redirect on clicking input field
  	jQuery('.product-count input.qty').click(function(e){
     e.preventDefault();
   });
    /* End of Quantity plus minus js */

    /* Menu Bar */

    var header = jQuery(".header-noscroll");
    jQuery(window).scroll(function() {    
      var scroll = jQuery(window).scrollTop();
      var height = jQuery(".site-header").height();

      if (scroll >= height) {
        header.removeClass('header-noscroll').addClass("header-scroll");
      } else {
        header.removeClass("header-scroll").addClass('header-noscroll');
      }
    });
    /* End of Menu Bar */

    /* Cart page cart management */
  //delivery time checked 
  jQuery(document).ready(function(){
   jQuery('.after-resident-select').on("click",'document',function(){
     console.log(jQuery(this).text());
     jQuery('.deliverytimewrap').find('input[type="radio"]').removeAttr('checked');
     jQuery(this).find('input[type="radio"]').prop('checked',true);
   });
 });
  
  	// Resident type selection
  	var deliveryselect = $('.delivery-date-select');
  	var resident = $("input:radio[name='attributes[Select resident type]']");
  	var afterdelivery = $('.after-selected'), residentwrapper = $('.resident-type-wrapper'), resident_delivery_wrap = $('.resident-delivery-wrap');
  	//reset radio on first reload
  	$("input:radio[name='attributes[Select resident type]']").prop('checked',false);

  	deliveryselect.hide(); afterdelivery.hide(); residentwrapper.hide();

  	resident.click(function() {
      var resident_type = $(this).val();
      checkoutbuttonstatus();
      switch($(this).val()) {
       case 'Residential':

       afterdelivery.hide();
       $("input:radio[name='attributes[Delivery Time]']").prop('checked',false);
       $("input:radio[name='attributes[Delivery Day time]']").prop('checked',false);
       $("input:radio[name='attributes[Delivery day]']").prop('checked', false);
       $('#selected-resident').show();
       showandgeneratedeliverydates();
            //gettime();
            $('#checkout_attributes_building_name,#checkout_attributes_gated_highrise_delivery_note,#checkout_attributes_business_name,#checkout_attributes_business_delivery_note,.delivery-time-select,.delivery-daytime-select').val('');
            break;
            case 'Residential (Gated/Highrise)':
            afterdelivery.hide();
            $("input:radio[name='attributes[Delivery Time]']").prop('checked',false);
            $("input:radio[name='attributes[Delivery Day time]']").prop('checked',false);
            $("input:radio[name='attributes[Delivery day]']").prop('checked', false);
            $('#selected-resident2').show();
            getapartmentoptions();
            showandgeneratedeliverydates();
            //getbusstime();
            $('#checkout_attributes_residential_delivery_note,#checkout_attributes_business_name,#checkout_attributes_business_delivery_note').val('');
            break;
            default:
         //Business
         afterdelivery.hide();
         $("input:radio[name='attributes[Delivery Time]']").prop('checked',false);
         $("input:radio[name='attributes[Delivery Day time]']").prop('checked',false);
         $("input:radio[name='attributes[Delivery day]']").prop('checked', false);
         $('#selected-business').show();
         showandgeneratedeliverydates();
            //getdaytime();
            $('#checkout_attributes_residential_delivery_note,#checkout_attributes_building_name,#checkout_attributes_gated_highrise_delivery_note,.delivery-daytime-select').val('');
          }
        });
    function getsimpledateformat(datearr){
      var finaldatearr = [];
      jQuery.each(datearr,function(key,dateval){
        finaldatearr.push(Date.parse(dateval).toString('yyyy/MM/dd'));
      });
      return finaldatearr;
    }

    function skippublicholiday(datearr){
      var public_holiday = ["2024/01/01","2024/01/02","2024/24/01","2024/25/02", "2024/04/30", "2024/04/27"];//["2017/04/28","2017/05/03"];
      //var dates = getsimpledateformat(datearr);
      var dates = datearr;

      var tueandthur = gettueandthur(dates);
      var firstdate = dates[0];
      var secdate = dates[2];
      var thirdate = dates[1];
      var fourthdate = dates[3];
      var xsecdate = dates[4];
      var xfourthdate = dates[5];
      //return [firstdate,secdate,thirdate,fourthdate];      

      if (firstdate!= null) {
        var isfirstdayholiday = 0;
        if(jQuery.inArray(firstdate, public_holiday) !== -1 || jQuery.inArray(tueandthur[0], public_holiday) !== -1){
          firstdate = addweeksandformat(firstdate,2);
          isfirstdayholiday = 1;
        }else{
          firstdate = addweeksandformat(firstdate,0);
        }
      }
      
      if (secdate!= null) {

        var issecdayholiday = 0;
        if(jQuery.inArray(secdate, public_holiday) !== -1 || jQuery.inArray(tueandthur[2], public_holiday) !== -1){
          secdate = addweeksandformat(secdate,2);
          issecdayholiday = 1;
        }else{
          secdate = addweeksandformat(secdate,0);
        }
      }

      if (xsecdate!= null) {
        var isxsectdayholiday = 0;
        if(jQuery.inArray(xsecdate, public_holiday) !== -1 || jQuery.inArray(tueandthur[0], public_holiday) !== -1){
          xsecdate = addweeksandformat(xsecdate,2);
          isxsectdayholiday = 1;
        }else{
          xsecdate = addweeksandformat(xsecdate,0);
        }
      }
      if (thirdate!= null) {
        if(jQuery.inArray(thirdate, public_holiday) !== -1 || jQuery.inArray(tueandthur[1], public_holiday) !== -1){
          var weektoadd = 0;
          if(isfirstdayholiday==1){ weektoadd = 2;}else{weektoadd=1}
          thirdate = addweeksandformat(thirdate,weektoadd);
        }else{
          thirdate = addweeksandformat(thirdate,0);
        }
      }

      if (xfourthdate!= null) {
        if(jQuery.inArray(xfourthdate, public_holiday) !== -1 || jQuery.inArray(tueandthur[3], public_holiday) !== -1){
          if(xsecdate==1){ weektoadd = 2;}else{weektoadd=1}
          xfourthdate = addweeksandformat(xfourthdate,weektoadd);
        }else{
          xfourthdate = addweeksandformat(xfourthdate,0);
        }
      }

      if (fourthdate!= null) {
        if(jQuery.inArray(fourthdate, public_holiday) !== -1 || jQuery.inArray(tueandthur[3], public_holiday) !== -1){
          if(issecdayholiday==1){ weektoadd = 2;}else{weektoadd=1}
          fourthdate = addweeksandformat(fourthdate,weektoadd);
        }else{
          fourthdate = addweeksandformat(fourthdate,0);
        }
      }
      
      if (xsecdate!=null) {
        var finalarr = [firstdate,secdate,thirdate,fourthdate,xsecdate,xfourthdate];
      }
      else if (secdate!= null) {
        var finalarr = [firstdate,secdate,thirdate,fourthdate];
      } else {
        var finalarr = [firstdate, thirdate];
      }
      finalarr.forEach(function(item, index) {
        var date = Date.parse(item).toString('yyyy/MM/dd');
        if (jQuery.inArray(date, public_holiday) !== -1) {
          finalarr.splice(index, 1);
        }
      });
      return sortdates(finalarr);
    }

  	//get tuesday and thursday
    function gettueandthur(datearr){
      var finaldates = [];
      jQuery.each(datearr,function(key,dateitem){
      	var reqdate = dateitem.split('/');
      	reqdate = reqdate[0]+'/'+reqdate[2]+'/'+reqdate[1];
        finaldates.push(Date.parse(reqdate).addDays(-1).toString('yyyy/MM/dd'));
      });
      return finaldates;
    }

  	//SORT DATE IN ASCENDING ORDER
    function sortdates(datearr){
      var finalarr = [];
      //CONVERT TO SECONDS
      jQuery.each(datearr,function(key,date){
        var date = Date.parse(date).toString('yyyy/MM/dd');
        var date = new Date(date);
        var seconds = date.getTime() / 1000;
        finalarr.push(seconds);
      });
      //SORT SECONDS
      finalarr = finalarr.sort(function (a, b) {  return a - b;  });
      //FORMAT DATE
      var dateformated = [];
      jQuery.each(finalarr,function(key,seconds){
      	dateformated.push(toDateTime(seconds));
      });
      return dateformated;
    }
  	//SECONDS TO DATE
  	function toDateTime(secs) {
      var myObj = $.parseJSON('{"date_created":'+secs+'}'),
      myDate = new Date(1000*myObj.date_created);
      return Date.parse(myDate).toString('ddd dS MMM yyyy');
    }

    function addweeksandformat(requestdate,week){
      var reqdate = requestdate.split('/');
      reqdate = reqdate[0]+'/'+reqdate[2]+'/'+reqdate[1];
      if(week!=0){
       return Date.parse(reqdate).addWeeks(week).toString('yyyy/dd/MM');
     }else{
       return Date.parse(reqdate).toString('yyyy/dd/MM');
     }
   }
   deliveryselect.click(function(){
    checkoutbuttonstatus();
  });
   if($("input:radio[name='attributes[Select resident type]']:checked").val()){
    showandgeneratedeliverydates();
  }
  
  function gettime() {
   var earlytime = ($(".times").html());
   var daytime = ($(".time").html());
   var time = [earlytime, daytime];
   if (earlytime == "" && daytime == "") {
    jQuery('p.delivery-busstime-select').hide();
    jQuery('#dtime').hide();
    jQuery('#dtimeb').hide();
  }
  var fruit = new Array();
  var i=0;
  time.forEach(function(entry) { 
   i++;
   var deliverydaytime;
   if (entry == "") {
     deliverydaytime == "";
   }
   else {
     deliverydaytime = '<div class="deliverytimewrap"><input required class="required" id="'+entry+'" type="radio" name="attributes[Delivery Time]" value="'+entry+'"  > <label for="'+entry+'">'+entry+'</label></div>';
     fruit.push(deliverydaytime); 
   }
 });
  jQuery('p.delivery-time-select').html(fruit);
}

function getnewtime(early,dayt,i) { 

  var time = [early[i],dayt[i]];
  if (early[i] == "" && dayt[i]== "") {
    jQuery('#dtimeb').hide();
  }
  var times = new Array();
  time.forEach(function(entry) { 
    var deliverydaytime;
    if (entry == "") {
      deliverydaytime == "";
    } else {
      deliverydaytime = '<div class="deliverytimewrap"><input required class="required" id="'+entry+''+entry+''+entry+'" type="radio" name="attributes[Delivery Time]" value="'+entry+'"  > <label for="'+entry+''+entry+''+entry+'">'+entry+'</label></div>';
      times.push(deliverydaytime);
    }
  });
  jQuery('p.delivery-newtime-select').html(times);
}


function getbusstime() {
 var earlytime = ($(".times").html());
 var daytime = ($(".time").html());
 var time = [earlytime, daytime];
 if (earlytime == "" && daytime == "") {
      //jQuery('p.delivery-busstime-select').hide();
      jQuery('#dtime').hide();
      jQuery('#dtimeb').hide();
    }
    var fruit = new Array();
    var i=0;
    time.forEach(function(entry) { 
     i++;
     var deliverydaytime;
     if (entry == "") {
       deliverydaytime == "";
     } else { 
       deliverydaytime = '<div class="deliverytimewrap"><input required class="required" id="'+entry+''+entry+''+entry+'" type="radio" name="attributes[Delivery Time]" value="'+entry+'"  > <label for="'+entry+''+entry+''+entry+'">'+entry+'</label></div>';
       fruit.push(deliverydaytime);
     }
   });
    jQuery('p.delivery-busstime-select').html(fruit);
  }
  function getdaytime() {
    var daytime = ($(".time").html());
    if (daytime == "") {
      jQuery('p.delivery-daytime-select').hide();
      jQuery('#dtimes').hide();
    }
    var deliverydaytime;
    deliverydaytime = '<div class="deliverytimewrap"><input required class="required" id="'+daytime+''+daytime+'" type="radio" name="attributes[Delivery Day time]" value="'+daytime+'" > <label for="'+daytime+''+daytime+'" >'+daytime+'</label></div>';
    jQuery('p.delivery-daytime-select').html(deliverydaytime);
  }
  
  function getapartmentoptions() {
    var apartmentoptions = ($(".apartment_options").html());
    if (apartmentoptions == 1 ){
      $('p#residential2-forbidden').hide();
      $('.apat').show();
    }
    else {
      $('p#residential2-forbidden').show();
      $('.apat').hide();
    }
  }
  
  
  function addDays(date,days)
  {
    //     console.log(date);
    let temp = new Date(date.toString('yyyy-MM-dd'));
    return temp.addDays(parseInt(days));
  }

  function getNextDate(date,cutoff,comingfri)
  {
    let temp = new Date(comingfri);
    let enddate = addDays(date,cutoff);
//     console.log(temp);
//     console.log(enddate);
//     console.log(enddate.getTime() <= temp.getTime());
//     console.log(cutoff);
//     console.log('=======================================================');
    if(enddate.getTime() <= temp.getTime() || cutoff === undefined)
      return temp;

    return getNextDate(date,cutoff,addDays(temp,7).toString('yyyy/MM/dd'));
  }

  //START OF CALCULATE CUTOFF
  ///////////////////////////

  function calculateCutoff(deliveryValue, cutoffValue) {
    // Parse the deliveryValue (e.g. "Tue 27th Aug 2024") into a date object
    const deliveryDate = parseDateString(deliveryValue);

    if (!deliveryDate) {
        console.error('Invalid delivery date format.');
        return;
    }

    // Set the time to 12 PM (noon) Sydney time for the delivery date
    deliveryDate.setHours(12, 0, 0, 0); // Set the delivery date to 12 PM (noon)

    // Convert the cutoffValue to an integer and calculate the cutoff date
    const cutoffDays = parseInt(cutoffValue) + 1; //IMPORTANT - adding 1 day to the cutoff to get the right date
    const cutoffDate = new Date(deliveryDate);

    // Subtract the cutoff days from the delivery date
    cutoffDate.setDate(deliveryDate.getDate() - cutoffDays);
    // console.log('Delivery Date:', deliveryDate);
    // console.log('Cutoff Day # + 1:', cutoffDays);
    // console.log('Cutoff Date:', cutoffDate);

    // Set the cutoff date to 12 PM as well, to align with the noon rule
    cutoffDate.setHours(12, 0, 0, 0);

    // Return the day of the week (e.g. "Mon", "Tue", etc.)
    return getDayOfWeek(cutoffDate);
  }

  function parseDateString(dateString) {
    // Remove the weekday and ordinal suffixes (e.g., "31st", "22nd") from the date string
    const cleanedDateString = dateString
        .replace(/^\w{3}\s/, '')    // Remove the weekday (e.g., "Tue")
        .replace(/(\d{1,2})(st|nd|rd|th)/, '$1') // Remove ordinal suffixes ("st", "nd", etc.)
        .trim(); // Trim any extra spaces

    // Now, try parsing the cleaned date string
    const parsedDate = new Date(cleanedDateString);

    if (isNaN(parsedDate)) {
        console.error('Failed to parse the date:', cleanedDateString);
        return null;
    }

    return parsedDate;
  }


  function getDayOfWeek(date) {
    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    // Get the day of the week in UTC to avoid timezone issues
    const dayIndex = (date.getUTCDay() + 6) % 7;  // Shift to start the week on Monday

    return days[dayIndex];
  }

  //END OF CALCULATE CUTOFF
  /////////////////////////


  function showandgeneratedeliverydates(){
    deliveryselect.show();
    var serverdate = $(".servertime").html();
    var serverdate = serverdate.replace(",", "");
    var data = ($(".day").html().split(","));
    var cutoffdays = ($(".cutoffdays").html().split(","));
    var early = ($(".early").html().split(","));
    var dayt = ($(".dayt").html().split(",")); 
    var gettime = serverdate.split(" ");
    var gettime  = gettime [gettime.length-1];
    var shippingdates = ($(".shippingdates").html().split(","));
    
    console.log('shippingdates:', shippingdates);
    var i=0;
    var deliverydatearray = new Array();
    var dayarray = new Array();
    let cutoffArrayDayNumberOff = {};  // Object to store the key-value pairs of days with their respective cutoffs

    cutoffdays = cutoffdays.filter(String);
    console.log('Cutoff after click:',cutoffdays);

    data.forEach(function(entry, index) {
      console.log('Entry:', entry);
      var text;
      switch (entry) {
        case "Sun": text = 0; break;
        case "Mon": text = 1; break;
        case "Tue": text = 2; break;
        case "Wed": text = 3; break;
        case "Thu": text = 4; break;
        case "Fri": text = 5; break;
        case "Sat": text = 6; break;
        default: text = 7;
      }
      
      if(entry == "" || text == 7) {
        i++;
        return;
      }
      //date of the day from csv
      var today = new Date(serverdate);
      var todaysdate = (gettime == "PM") ? today.addDays(1) : today;

      //delivery day date (day from csv)
      //console.log(serverdate);
      var today = new Date(serverdate);
      var day = today.getDay() || 7;
      var deliverydatehour = (today.setHours(-24 * (day - text)));
      var deliverydate = (today.toString('yyyyMMdd'));
      var weekdays = 7;
      var extradays = 0;

      // if(cutoffdays[i] >= 7){ 
      //   console.log('cutoffdays:', cutoffdays[i]);
      //   extradays = (cutoffdays[i]-6);
      //   console.log('extradays:', extradays);
      // }

      if(addDays(today,weekdays).getTime() <= addDays(todaysdate,parseInt(extradays)+parseInt(cutoffdays[i])).getTime()){
        additional = 2;
      } else if(addDays(todaysdate,cutoffdays[i]) >= today.getTime() && addDays(todaysdate,weekdays) >= addDays(today,cutoffdays[i]).getTime()){
        additional = 1;
      } else{
        additional = 0;
      }

      var comingfri = today.addWeeks(additional).toString('yyyy/MM/dd');
      console.log('comingfri:', comingfri);
      cutoffdays_range = cutoffdays[i];
      if(cutoffdays_range === undefined){
        cutoffdays_range = cutoffdays[0]
      }

      today = getNextDate(todaysdate,cutoffdays_range,comingfri);
      comingfri = today.toString('yyyy/MM/dd');
      deliveryselect.show();
      var nextfri = today.addWeeks(1).toString('yyyy/MM/dd'); 
      var public_holiday = ["2024/01/01","2024/01/02","2024/24/01","2024/25/02", "2024/04/30", "2024/04/27", "2024/07/14","2024/07/15","2024/07/16","2024/07/17","2024/07/18","2024/07/19"];//["2017/04/28","2017/05/03"];
      //var deliveryarray = skippublicholiday([comingfri,nextfri]);
      var deliveryarray = [comingfri,nextfri];
      deliverydatearray.push(comingfri,nextfri);
      var deliveryarrayval = getsimpledateformat(deliveryarray);
      cutoffArrayDayNumberOff[entry] = cutoffdays[index];  // Set key-value pair for the day and its respective cutoff
      i++;
    });

    var deliverydateshtml= '', deliverydateselector = $('p.delivery-date-select');
    var dayarray = skippublicholiday(deliverydatearray);
    //dayarray = sortdates(dayarray);
    jQuery.each(dayarray,function(key,item){
      let valueDay = item.replace(' ','').slice(0,3);
      deliverydateshtml += '<div class="deliverydatewrap" data-index="' + key + '"><input class="required" data-cutoff="'+cutoffArrayDayNumberOff[valueDay]+'" id="'+item.replace(' ','').replace(' ','')+'" type="radio"  name="attributes[Delivery day]" value="'+dayarray[key]+'"> <label for="'+item.replace(' ','').replace(' ','')+'">'+item+'</label></div>';
    });

    deliverydateselector.find('span').html(deliverydateshtml);
    $('.deliverydatewrap').change(function(){
      console.log('change event:');
      $('#dnewtime').text("4. Delivery time*"); 
      var deliveryvalue = $.trim($("input:radio[name='attributes[Delivery day]']:checked").val());
      var days = (deliveryvalue.slice(0,3));
      //console.log('deliveryvalue: ', deliveryvalue);
      //console.log('deliverydatearray: ', deliverydatearray);

      let cutoffValueFromIndex = $.trim($("input:radio[name='attributes[Delivery day]']:checked").attr('data-cutoff'));  // $ refers to the clicked radio button
      console.log('Cutoff Value:', cutoffValueFromIndex);
      // Calculate and log the cutoff day
      const cutoffDay = calculateCutoff(deliveryvalue, cutoffValueFromIndex);
      //console.log('Cutoff Day:', cutoffDay);


      if (isNaN(deliveryvalue.slice(3,6))) {
        var deliveryvaluedate = deliveryvalue.slice(3,5);
      }
      else {
        var deliveryvaluedate = deliveryvalue.slice(3,6);
      }

      if (days == data[0]) {
        var i=0;
        getnewtime(early,dayt,i);
      } else if(days == data[1]) {
        var i=1;
        getnewtime(early,dayt,i);
      }
      else {
        var i=2;
        getnewtime(early,dayt,i);
      }

      jQuery.each(deliverydatearray,function(key,item){
        var dates = (item.split('/')[2]);
        // console.log('dates:', dates);
        // console.log('deliveryvaluedate:', deliveryvaluedate);
          if (Number(dates) == Number(deliveryvaluedate)) {
          var shippingdate = new Date(item);
          console.log('original:', shippingdate)
          var shippingdate = (shippingdate.addDays(-(shippingdates[i])).toString('yyyy-MM-dd'));
           console.log('updated:', shippingdate)
          var shipping;
          shipping = '<input type="text" name="attributes[Shipping Dates]" value="'+shippingdate+'">';
          jQuery('.shipping-date').html(shipping);
          var cutoffday;
          cutoffday = '<input type="text" name="attributes[Cutoff Day]" value="'+cutoffDay+'">';
          jQuery('.cutoff-day').html(cutoffday);
           
          //  fetch('/cart', {
          //     method: 'POST',
          //     headers: {
          //       'Accept': 'application/json',
          //       'Content-Type': 'application/json'
          //     },
          //     body: JSON.stringify({
          //         attributes: {
          //             ['Shipping Dates']: shippingdate
          //         }
          //     })
          // });
           
           }
       });
      });
       checkoutbuttonstatus();

     }
     function cartpostcoderesponse(status){
      if(status==true){
      	resident_delivery_wrap.show();
        residentwrapper.show();
      }else{
        //reset all values field previously
        $("input:radio[name='attributes[Delivery day]']").prop('checked', false);
        $('#checkout_attributes_residential_delivery_note,#checkout_attributes_building_name,#checkout_attributes_gated_highrise_delivery_note,#checkout_attributes_business_name,#checkout_attributes_business_delivery_note').val('');
        $("input:radio[name='attributes[Select resident type]']").prop('checked',false);
        $('#selected-resident2,.delivery-date-select').hide();
        resident_delivery_wrap.hide();
      }
      checkoutbuttonstatus();
    }

  	//onstated typing on required input field
  	checkrequiredinputkeyup(jQuery('input#checkout_attributes_business_name'));
    checkrequiredinputkeyup(jQuery('input#checkout_attributes_building_name'));
    checkrequiredinputkeyup(jQuery('#checkout_attributes_business_delivery_note'));
    checkrequiredinputkeyup(jQuery('#checkout_attributes_gated_highrise_delivery_note'));
    buttonchange((jQuery(document)));
    function checkrequiredinputkeyup(targetinput){
      targetinput.keyup(function(){
        if($(this).val()){
          targetinput.css('border-color','#e8e9eb');
        }
        checkoutbuttonstatus();
      });
    }

    function buttonchange(targetinput){
     targetinput.on("change",".deliverytimewrap input:radio[name='attributes[Delivery Time]']",function(){
       jQuery('.deliverytimewrap').css('border-color','#e8e9eb');
       checkoutbuttonstatus();
     });
     targetinput.on("change",".deliverydatewrap input:radio[name='attributes[Delivery Day]']",function(){
       jQuery('.deliverytimewrap').css('border-color','#e8e9eb');
       checkoutbuttonstatus();
     });
   } 

  	//check if all the required field are filled
    function checkoutbuttonstatus(){
      //console.log('triggered');
      var postcodeinput = $("#cpostcode_input");
      var postcodevalue = $.trim(postcodeinput.val());
      var deliveryvalue = $.trim($("input:radio[name='attributes[Delivery day]']:checked").val());
      var residentvalue = $.trim($("input:radio[name='attributes[Select resident type]']:checked").val());
      var deliverytime = $.trim($("input:radio[name='attributes[Delivery Time]']:checked").val());
      var shippingDates = $.trim($("[name='attributes[Shipping Dates]']").val());
      jQuery(document).on("change",".deliverydatewrap input:radio[name='attributes[Delivery day]']",function(){
       $("input:radio[name='attributes[Delivery Time]']").prop('checked',false);
       $('.checkoutbutton').prop("disabled", true);
     });
      if(postcodevalue.length>0 && residentvalue.length>0 && deliveryvalue.length > 0 && deliverytime.length > 0 && shippingDates.length > 0){


        //check for required input field
        var requiredinputres = 1; var requiredinputbusiness1 = 1;var requiredinputbusiness2 = 1; var requiredinputbusiness3 = 1; var requiredinputgated1 = 1;var requiredinputgated2 = 1; var requiredinputgated3 =1;

        
        if(residentvalue=='Business'){
          var requiredinput1 = jQuery('input#checkout_attributes_business_name');
          var requiredinput2 = jQuery('#checkout_attributes_business_delivery_note');
          
          if(!requiredinput1.val()){
            requiredinputbusiness1 = 0;
            requiredinput1.css('border-color','red');
          }
          if(!requiredinput2.val()){
            requiredinputbusiness2 = 0;
            requiredinput2.css('border-color','red');
          }
          // if all required input fields are filled
          if(requiredinputbusiness1==1 && requiredinputbusiness2==1){
            checkoutbuttonstatussuccess();
          }else{
            $('.checkoutbutton').prop("disabled", true);
          }
        }else if(residentvalue=='Residential (Gated/Highrise)'){
          var requiredinput2 = jQuery('#checkout_attributes_gated_highrise_delivery_note');
          

          if(!requiredinput2.val()){
            requiredinputgated2 = 0;
            requiredinput2.css('border-color','red');
          }
          	//if all required input fileds are filled
          	if(requiredinputgated2==1){
              checkoutbuttonstatussuccess();
            }else{
              $('.checkoutbutton').prop("disabled", true);
            }
          }else{
            checkoutbuttonstatussuccess();
          }

        }else{
         $('.checkoutbutton').prop("disabled", true);
       }  
     }

     function checkoutbuttonstatussuccess(){

      var time =$.trim($("input:radio[name='attributes[Delivery Time]']:checked").val());
      $(".checkoutbutton").attr('name', 'checkout');
      $('.checkoutbutton').prop("disabled", false);


    }

    /* End of Cart page cart management */

    //check if my class exist
    if ($(".product-gallery")[0]){
      /* Slick slider product gallery */
      $('.product-gallery .full-images').slick({
      dots: true,
      arrows: true,
      adaptiveHeight: true,
      slidesToShow: 1,
      autoplay: false,
      infinite: false,
      pauseOnHover: true,
      asNavFor: '.product-gallery .thumbs'
    }).addClass('ready');

      $('.product-gallery .thumbs').slick({
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: true,
        asNavFor: '.product-gallery .full-images'
      }).addClass('ready');
      // lightbox.option({
      //   'disableScrolling': true
      // })
      /* End of Slick slider gallery */
    }

    $("#Quantity,.qty").keydown(function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
        // Allow: Ctrl+A, Command+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || 
        // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)) {
      // let it happen, don't do anything
    return;
  }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  });


  //this is start of post code validation
  function showJsonList(value){
    jQuery("#postcode_input").autocomplete({
      source: function( request, response ) {
        jQuery.ajax({
          method:'GET',
          url: "https://apiv2.goodmeal.com.au/getapi/searchsuburbtest/find",
          crossDomain: true,
          async:true,
          dataType: 'json',
          data:{ code: value },
          beforeSend: function(){
            jQuery('button.postcode__submit').prop('disabled', true);
            jQuery('form.checkpostcodeform .input-group span.input-group__btn').addClass('notallowed');
          },
          success: function(data){
            var res = new Array();
            for(var k in data) {
             res.push(data[k].split(",")[0] + "," + data[k].split(",")[1]);
           }
           response(res);
         },
         complete: function(dataa) { 
          jQuery('button.postcode__submit').prop('disabled', false);
          jQuery('form.checkpostcodeform .input-group span.input-group__btn').removeClass('notallowed');
        }
      });
      },
      select: function( event, ui ) {
        jQuery('.postcoderesult1').html("<span>Yes, we deliver in the area "+ui.item.value+"</span>");
        jQuery('button.postcode__submit').prop('disabled', true);
        jQuery('form.checkpostcodeform .input-group span.input-group__btn').addClass('notallowed');
      },
      response: function(event, ui) {
        // ui.content is the array that's about to be sent to the response callback.
        if (ui.content.length === 0) {
          jQuery('button.postcode__submit').prop('disabled', true);
          jQuery('form.checkpostcodeform .input-group span.input-group__btn').addClass('notallowed');
          jQuery(".postcoderesult1").html("<span>Sorry, No results found!</span>");
        } else {
          jQuery(".postcoderesult1").empty();
          jQuery('button.postcode__submit').prop('disabled', false);
          jQuery('form.checkpostcodeform .input-group span.input-group__btn').removeClass('notallowed');
        }     
      },
      minLength: 3,
      autoFocus: true
    });
  }
  
  function showJsonListCart(value){
    jQuery("#cpostcode_input").autocomplete({
      source: function( request, response ) {
        jQuery.ajax({
          method:'GET',
          url: "https://apiv2.goodmeal.com.au/getapi/searchsuburbtest/find",
          //url: "https://magento.draftserver.com/goodmealapi/getapi/newsearch/find",
          crossDomain: true,
          async:true,
          dataType: 'json',
          data:{ code: value },
          beforeSend: function(){
            console.log('loading');
            jQuery('button.postcode__submit').prop('disabled', true);
            jQuery('form.cart .input-group span.input-group__btn').addClass('notallowed');
          },
          success: function(data){
            var res = new Array();
            for(var k in data) {
              res.push(data[k].split(",")[0] + "," + data[k].split(",")[1]);
            }
            console.log('success');
            response(res);
            jQuery('.suggest').html(data ).hide(); 
          },
          complete: function(dataa) { 
            console.log('loading done');
            jQuery('button.postcode__submit').prop('disabled', false);
            jQuery('form.cart .input-group span.input-group__btn').removeClass('notallowed');
          }
        });
      },
      select: function( event, ui ) {
            jQuery('#checout-postcode-spinner').show()
//           var data = ($(".suggest").html().split("||"));
//             data.forEach(function(entry) {
//               if((entry.split(",")[0] + "," +entry.split(",")[1]) == ui.item.value) {
//                 var length = entry.split(",").length;
//                 if (length >=16) {
//                   var apartmentoptions = entry.split(",")[length-5];
//                   var day = [entry.split(".")[1],',',entry.split(",")[length-12],',',entry.split(",")[length-6]];
//                   var early = [entry.split(",")[length-16],',',entry.split(",")[length-10],',',entry.split(",")[length-4]];
//                   var dayt = [entry.split(",")[length-15],',',entry.split(",")[length-9],',',entry.split(",")[length-3]];
//                   var cutoffdays = [entry.split(",")[length-14],',',entry.split(",")[length-8],',',entry[entry.length - 3]];
//                   var shippingdates = [entry.split(",")[length-13],',',entry.split(",")[length-7],',',entry[entry.length - 1]];

//                 }

//                 else if(length <=10 ) {
//                   var day = entry.split(".")[1];
//                   var apartmentoptions = entry.split(",")[length-5];
//                   var early = entry.split(",")[length-4];
//                   var dayt = entry.split(",")[length-3];
//                   var cutoffdays = entry[entry.length - 3];
//                   var shippingdates = entry[entry.length - 1];
//                 }
//                 else  {
//                   var apartmentoptions = entry.split(",")[length-5];
//                   var day = [entry.split(".")[1],',',entry.split(",")[length-6]];
//                   var early = [entry.split(",")[length-10],',',entry.split(",")[length-4]];
//                   var dayt = [entry.split(",")[length-9],',',entry.split(",")[length-3]];
//                   var cutoffdays = [entry.split(",")[length-8],',',entry[entry.length - 3]];
//                   var shippingdate = [entry.split(",")[length-7],',',entry[entry.length - 1]];
//                   var earlydelivery = entry.split(",")[length-3];
//                   var daytimedelivery = entry.split(",")[length-2];
//                   var shippingdates = [entry.split(",")[8],',',entry.split(",")[length-1]];_

//                 }
//               };

//               jQuery('.day').html(day).hide();
//               jQuery('.time').html(daytimedelivery).hide();
//               jQuery('.times').html(earlydelivery).hide();
//               jQuery('.apartment_options').html(apartmentoptions).hide();
//               jQuery('.cutoffdays').html(cutoffdays).hide();
//               jQuery('.early').html(early).hide();
//               jQuery('.dayt').html(dayt).hide();
//               jQuery('.shippingdates').html(shippingdates).hide();
//             });

//             jQuery('.suggestions').html("<span>Yes, we deliver in the area "+ui.item.value+"</span>");
//             cartpostcoderesponse(true);
//             jQuery('button.postcode__submit').prop('disabled', true);
//             jQuery('form.cart .input-group span.input-group__btn').addClass('notallowed');

        checkAvailable.init(ui.item.value)
        .then((res) => {
          if(!res){
            var data = ($(".suggest").html().split("||"));
            console.log(res);
            console.log(data);
            data.forEach(function(entry) {
              if((entry.split(",")[0] + "," +entry.split(",")[1]) == ui.item.value) {
                var length = entry.split(",").length;
//                 console.log("1==============================================");
//                 console.log(length);
//                 console.log(entry.split(","));
//                 console.log("2==============================================");
                if (length >=16) {

                  //var apartmentoptions = entry.split(",")[length-5];
                  var apartmentoptions = entry.split(",")[4];
                  var day = [entry.split(".")[1],',',entry.split(",")[length-12],',',entry.split(",")[length-6]];
                  var early = [entry.split(",")[length-16],',',entry.split(",")[length-10],',',entry.split(",")[length-4]];
                  var dayt = [entry.split(",")[length-15],',',entry.split(",")[length-9],',',entry.split(",")[length-3]];
                  var cutoffdays = [entry.split(",")[length-14],',',entry.split(",")[length-8],',',entry[entry.length - 3]];
                  var shippingdates = [entry.split(",")[length-13],',',entry.split(",")[length-7],',',entry[entry.length - 1]];
//                   console.log('Cutoff dates',cutoffdays);
//                   console.log(entry);
                } else if(length <=10 ) {
                  var day = entry.split(".")[1];
                  //var apartmentoptions = entry.split(",")[length-5];
                  var apartmentoptions = entry.split(",")[4];
                  var early = entry.split(",")[length-4];
                  var dayt = entry.split(",")[length-3];
                  //var cutoffdays = entry[entry.length - 3];
                  //var shippingdates = entry[entry.length - 1];

                  var cutoffdays = entry.split(",")[length - 2];
                  var shippingdates = entry.split(",")[length - 1];
//                   console.log('Cutoff dates',cutoffdays);

                } else  {
                  //var apartmentoptions = entry.split(",")[length-5];
                  var apartmentoptions = entry.split(",")[4];
                  var day = [entry.split(".")[1],',',entry.split(",")[length-6]];
                  var early = [entry.split(",")[length-10],',',entry.split(",")[length-4]];
                  var dayt = [entry.split(",")[length-9],',',entry.split(",")[length-3]];
                  var cutoffdays = [entry.split(",")[length-8],',',entry[entry.length - 3]];
                  var shippingdate = [entry.split(",")[length-7],',',entry[entry.length - 1]];
                  var earlydelivery = entry.split(",")[length-3];
                  var daytimedelivery = entry.split(",")[length-2];
                  var shippingdates = [entry.split(",")[8],',',entry.split(",")[length-1]];_
//                   console.log('Cutoff dates',cutoffdays);
                }
              };

              jQuery('.day').html(day).hide();
              jQuery('.time').html(daytimedelivery).hide();
              jQuery('.times').html(earlydelivery).hide();
              jQuery('.apartment_options').html(apartmentoptions).hide();
              jQuery('.cutoffdays').html(cutoffdays).hide();
              jQuery('.early').html(early).hide();
              jQuery('.dayt').html(dayt).hide();
              jQuery('.shippingdates').html(shippingdates).hide();
            });

            jQuery('.suggestions').html("<span>Yes, we deliver in the area "+ui.item.value+"</span>");
            cartpostcoderesponse(true);
            jQuery('button.postcode__submit').prop('disabled', true);
            jQuery('form.cart .input-group span.input-group__btn').addClass('notallowed');
            $("input:radio[name='attributes[Select resident type]']:checked").trigger('click');

          }
          jQuery('#checout-postcode-spinner').hide()
        });


      },
      response: function(event, ui) {
        // ui.content is the array that's about to be sent to the response callback.
        if (ui.content.length === 0) {
          jQuery('button.postcode__submit').prop('disabled', true);
          jQuery('form.cart .input-group span.input-group__btn').addClass('notallowed');
          jQuery(".suggestions").html("<span>Sorry, no results found!</span>");
          cartpostcoderesponse(false);
        } else {
          jQuery(".suggestions").empty();
          jQuery('button.postcode__submit').prop('disabled', false);
          jQuery('form.cart .input-group span.input-group__btn').removeClass('notallowed');
        }     
      },
      minLength: 3,
      autoFocus: true
    });
  }

jQuery("#postcode_input").on("keyup", function( event ){
 var value = this.value;
 showJsonList(value);
});

jQuery('#searchPostcodesBtn').on('click', function(event){
  const value = jQuery("#cpostcode_input").val();
  $( '#cpostcode_input' ).keydown();
})

jQuery("#cpostcode_input").on("keyup", function( event ){
 var value = this.value;
 showJsonListCart(value);
 // if (value == "") {
 //   location.reload();
 // }
    // deliveryselect.hide();
     //afterdelivery.hide();
//      residentwrapper.hide();
});


jQuery('button.footerButtonClick').on('click',function(e){
  e.preventDefault();
  if(!jQuery("button.footerButtonClick").is(":disabled")){
    if(!jQuery('form.checkpostcodeform .input-group span.input-group__btn').hasClass('notallowed')){

      if(jQuery('input#postcode_input').val().trim()==''){
      	jQuery(".postcoderesult1").html("<span>Please Enter a Value</span>"); 
        cartpostcoderesponse(false);
      }
      else{
        jQuery(".postcoderesult1").html("<span>Sorry, no delivery in that area. Please choose a location from drop down options.</span>"); 
        cartpostcoderesponse(false);
      }
    }
  }
});

jQuery('button.cart-postcode-check').on('click',function(e){
  e.preventDefault();
  if(!jQuery("button.cart-postcode-check").is(":disabled")){
    if(!jQuery('form.checkpostcodeform .input-group span.input-group__btn').hasClass('notallowed')){

      if(jQuery('input#cpostcode_input').val().trim()==''){
      	jQuery(".suggestions").html("<span>Please Enter a Value</span>"); 
        cartpostcoderesponse(false);
      }
      else{
        jQuery(".suggestions").html("<span>Sorry, no delivery in that area. Please choose a location from drop down options.</span>"); 
        cartpostcoderesponse(false);
      }
    }
  }
});

  //this is end of post code validation
  
});

/************JS for animate on scroll**************/

$(document).ready(function () {
  /************waypoint**************/
// Generated by CoffeeScript 1.6.2
/*!
jQuery Waypoints - v2.0.5
Copyright (c) 2011-2014 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/jquery-waypoints/blob/master/licenses.txt
*/
(function(){var t=[].indexOf||function(t){for(var e=0,n=this.length;e<n;e++){if(e in this&&this[e]===t)return e}return-1},e=[].slice;(function(t,e){if(typeof define==="function"&&define.amd){return define("waypoints",["jquery"],function(n){return e(n,t)})}else{return e(t.jQuery,t)}})(window,function(n,r){var i,o,l,s,f,u,c,a,h,d,p,y,v,w,g,m;i=n(r);a=t.call(r,"ontouchstart")>=0;s={horizontal:{},vertical:{}};f=1;c={};u="waypoints-context-id";p="resize.waypoints";y="scroll.waypoints";v=1;w="waypoints-waypoint-ids";g="waypoint";m="waypoints";o=function(){function t(t){var e=this;this.$element=t;this.element=t[0];this.didResize=false;this.didScroll=false;this.id="context"+f++;this.oldScroll={x:t.scrollLeft(),y:t.scrollTop()};this.waypoints={horizontal:{},vertical:{}};this.element[u]=this.id;c[this.id]=this;t.bind(y,function(){var t;if(!(e.didScroll||a)){e.didScroll=true;t=function(){e.doScroll();return e.didScroll=false};return r.setTimeout(t,n[m].settings.scrollThrottle)}});t.bind(p,function(){var t;if(!e.didResize){e.didResize=true;t=function(){n[m]("refresh");return e.didResize=false};return r.setTimeout(t,n[m].settings.resizeThrottle)}})}t.prototype.doScroll=function(){var t,e=this;t={horizontal:{newScroll:this.$element.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.$element.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};if(a&&(!t.vertical.oldScroll||!t.vertical.newScroll)){n[m]("refresh")}n.each(t,function(t,r){var i,o,l;l=[];o=r.newScroll>r.oldScroll;i=o?r.forward:r.backward;n.each(e.waypoints[t],function(t,e){var n,i;if(r.oldScroll<(n=e.offset)&&n<=r.newScroll){return l.push(e)}else if(r.newScroll<(i=e.offset)&&i<=r.oldScroll){return l.push(e)}});l.sort(function(t,e){return t.offset-e.offset});if(!o){l.reverse()}return n.each(l,function(t,e){if(e.options.continuous||t===l.length-1){return e.trigger([i])}})});return this.oldScroll={x:t.horizontal.newScroll,y:t.vertical.newScroll}};t.prototype.refresh=function(){var t,e,r,i=this;r=n.isWindow(this.element);e=this.$element.offset();this.doScroll();t={horizontal:{contextOffset:r?0:e.left,contextScroll:r?0:this.oldScroll.x,contextDimension:this.$element.width(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:r?0:e.top,contextScroll:r?0:this.oldScroll.y,contextDimension:r?n[m]("viewportHeight"):this.$element.height(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};return n.each(t,function(t,e){return n.each(i.waypoints[t],function(t,r){var i,o,l,s,f;i=r.options.offset;l=r.offset;o=n.isWindow(r.element)?0:r.$element.offset()[e.offsetProp];if(n.isFunction(i)){i=i.apply(r.element)}else if(typeof i==="string"){i=parseFloat(i);if(r.options.offset.indexOf("%")>-1){i=Math.ceil(e.contextDimension*i/100)}}r.offset=o-e.contextOffset+e.contextScroll-i;if(r.options.onlyOnScroll&&l!=null||!r.enabled){return}if(l!==null&&l<(s=e.oldScroll)&&s<=r.offset){return r.trigger([e.backward])}else if(l!==null&&l>(f=e.oldScroll)&&f>=r.offset){return r.trigger([e.forward])}else if(l===null&&e.oldScroll>=r.offset){return r.trigger([e.forward])}})})};t.prototype.checkEmpty=function(){if(n.isEmptyObject(this.waypoints.horizontal)&&n.isEmptyObject(this.waypoints.vertical)){this.$element.unbind([p,y].join(" "));return delete c[this.id]}};return t}();l=function(){function t(t,e,r){var i,o;if(r.offset==="bottom-in-view"){r.offset=function(){var t;t=n[m]("viewportHeight");if(!n.isWindow(e.element)){t=e.$element.height()}return t-n(this).outerHeight()}}this.$element=t;this.element=t[0];this.axis=r.horizontal?"horizontal":"vertical";this.callback=r.handler;this.context=e;this.enabled=r.enabled;this.id="waypoints"+v++;this.offset=null;this.options=r;e.waypoints[this.axis][this.id]=this;s[this.axis][this.id]=this;i=(o=this.element[w])!=null?o:[];i.push(this.id);this.element[w]=i}t.prototype.trigger=function(t){if(!this.enabled){return}if(this.callback!=null){this.callback.apply(this.element,t)}if(this.options.triggerOnce){return this.destroy()}};t.prototype.disable=function(){return this.enabled=false};t.prototype.enable=function(){this.context.refresh();return this.enabled=true};t.prototype.destroy=function(){delete s[this.axis][this.id];delete this.context.waypoints[this.axis][this.id];return this.context.checkEmpty()};t.getWaypointsByElement=function(t){var e,r;r=t[w];if(!r){return[]}e=n.extend({},s.horizontal,s.vertical);return n.map(r,function(t){return e[t]})};return t}();d={init:function(t,e){var r;e=n.extend({},n.fn[g].defaults,e);if((r=e.handler)==null){e.handler=t}this.each(function(){var t,r,i,s;t=n(this);i=(s=e.context)!=null?s:n.fn[g].defaults.context;if(!n.isWindow(i)){i=t.closest(i)}i=n(i);r=c[i[0][u]];if(!r){r=new o(i)}return new l(t,r,e)});n[m]("refresh");return this},disable:function(){return d._invoke.call(this,"disable")},enable:function(){return d._invoke.call(this,"enable")},destroy:function(){return d._invoke.call(this,"destroy")},prev:function(t,e){return d._traverse.call(this,t,e,function(t,e,n){if(e>0){return t.push(n[e-1])}})},next:function(t,e){return d._traverse.call(this,t,e,function(t,e,n){if(e<n.length-1){return t.push(n[e+1])}})},_traverse:function(t,e,i){var o,l;if(t==null){t="vertical"}if(e==null){e=r}l=h.aggregate(e);o=[];this.each(function(){var e;e=n.inArray(this,l[t]);return i(o,e,l[t])});return this.pushStack(o)},_invoke:function(t){this.each(function(){var e;e=l.getWaypointsByElement(this);return n.each(e,function(e,n){n[t]();return true})});return this}};n.fn[g]=function(){var t,r;r=arguments[0],t=2<=arguments.length?e.call(arguments,1):[];if(d[r]){return d[r].apply(this,t)}else if(n.isFunction(r)){return d.init.apply(this,arguments)}else if(n.isPlainObject(r)){return d.init.apply(this,[null,r])}else if(!r){return n.error("jQuery Waypoints needs a callback function or handler option.")}else{return n.error("The "+r+" method does not exist in jQuery Waypoints.")}};n.fn[g].defaults={context:r,continuous:true,enabled:true,horizontal:false,offset:0,triggerOnce:false};h={refresh:function(){return n.each(c,function(t,e){return e.refresh()})},viewportHeight:function(){var t;return(t=r.innerHeight)!=null?t:i.height()},aggregate:function(t){var e,r,i;e=s;if(t){e=(i=c[n(t)[0][u]])!=null?i.waypoints:void 0}if(!e){return[]}r={horizontal:[],vertical:[]};n.each(r,function(t,i){n.each(e[t],function(t,e){return i.push(e)});i.sort(function(t,e){return t.offset-e.offset});r[t]=n.map(i,function(t){return t.element});return r[t]=n.unique(r[t])});return r},above:function(t){if(t==null){t=r}return h._filter(t,"vertical",function(t,e){return e.offset<=t.oldScroll.y})},below:function(t){if(t==null){t=r}return h._filter(t,"vertical",function(t,e){return e.offset>t.oldScroll.y})},left:function(t){if(t==null){t=r}return h._filter(t,"horizontal",function(t,e){return e.offset<=t.oldScroll.x})},right:function(t){if(t==null){t=r}return h._filter(t,"horizontal",function(t,e){return e.offset>t.oldScroll.x})},enable:function(){return h._invoke("enable")},disable:function(){return h._invoke("disable")},destroy:function(){return h._invoke("destroy")},extendFn:function(t,e){return d[t]=e},_invoke:function(t){var e;e=n.extend({},s.vertical,s.horizontal);return n.each(e,function(e,n){n[t]();return true})},_filter:function(t,e,r){var i,o;i=c[n(t)[0][u]];if(!i){return[]}o=[];n.each(i.waypoints[e],function(t,e){if(r(i,e)){return o.push(e)}});o.sort(function(t,e){return t.offset-e.offset});return n.map(o,function(t){return t.element})}};n[m]=function(){var t,n;n=arguments[0],t=2<=arguments.length?e.call(arguments,1):[];if(h[n]){return h[n].apply(null,t)}else{return h.aggregate.call(null,n)}};n[m].settings={resizeThrottle:100,scrollThrottle:30};return i.on("load.waypoints",function(){return n[m]("refresh")})})}).call(this);

function onScrollInit( items, trigger ) {
  items.each( function() {
    var osElement = $(this),
    osAnimationClass = osElement.attr('data-os-animation'),
    osAnimationDelay = osElement.attr('data-os-animation-delay');

    osElement.css({
      '-webkit-animation-delay':  osAnimationDelay,
      '-moz-animation-delay':     osAnimationDelay,
      'animation-delay':          osAnimationDelay
    });

    var osTrigger = ( trigger ) ? trigger : osElement;

    osTrigger.waypoint(function() {
      osElement.addClass('animated').addClass(osAnimationClass);
    },{
      triggerOnce: true,
      offset: '80%'
    });
  });
}

onScrollInit( $('.animation') );
onScrollInit( $('.staggered-animation'), $('.staggered-animation-container') );


$("#nav-faq-category").find("a").click(function(e) {
  e.preventDefault();
  var section = $(this).attr("href");
  $("html, body").animate({scrollTop: $(section).offset().top-150}, 800);
});
});

/* Check for input field valaidation : postal code, only allowing numbers, backspace and arrows */
function validateQty(event) {
  var key = window.event ? event.keyCode : event.which;
  if (event.keyCode == 8 || event.keyCode == 46
   || event.keyCode == 37 || event.keyCode == 39) {
    return true;
}
else if ( key < 48 || key > 57 ) {
  return false;
}
else return true;
};
/*end of input field validation*/

/* Add to cart Ajax */
function addtocartajax(ele,qty,variantid,handle){
    //check for the quantity with stock
    //GET /products/<product-handle>.js
    /*
    var stockinstore = 0;
    jQuery.ajax({
        url: '/products/'+handle+'.js',
        dataType: 'json',
        type: 'get',
        success: function(product){
          var variants = product.variants;
          $.each(variants, function(index, element){
            if(element.id==variantid){
              stockinstore = element.inventory_quantity;
              console.log(stockinstore);
              if(stockinstore==0){
                jQuery(ele).text('Sold Out');
                jQuery(ele).attr('disabled','disabled');
                return false;
              }
            }
          });
        },
        complete: function(){
          //jQuery(ele).text('add to cart');
        },
        error :function( jqXhr ) {
          if( jqXhr.status === 422 ) {
              console.log(jqXhr);
          }
        }
      });
      */
    //ajax add to cart
    var item = {'quantity':qty,'id':variantid};
    jQuery.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: item,
      beforeSend: function(){
        jQuery(ele).text('adding...');
      },success: function(cart){
        console.log('from success '+cart.responseText);
        updatecartcount();
        updateminicart();
      },
      complete: function(){
        jQuery(ele).text('add to cart');
        jQuery('.mini-cart').slideDown('300');
      },
      error :function( jqXhr ) {
          //outof stock or higher stock added in cart handle
          if( jqXhr.status === 422 ) {
            var response = jqXhr.responseText;
            response = jQuery.parseJSON(response);
            var message = response.message;
            var description = response.description;
            alert(message+' : '+description);
          }
        }//error: Shopify.addItemstoTheCart
      });

    return false;
  }
  function updatecartcount(){
    if(window.refreshBarData) window.refreshBarData();
    //if added for the first time, add cart count container
    if(!jQuery('.cart-icon').find('#CartCount').length){
      
      jQuery('.cart-icon').append('<div id="CartCount" class="cart-count"><span></span></div>');
    }
    //update the count instantly
    jQuery.getJSON('/cart.js', function(cart){
      // console.log(cart.item_count);
      // console.log(cart.total_price, theme.moneyFormat);
      var total_price = cart.total_price/Math.pow(10,2);
      $('.cart-tital-price span').text('$'+ total_price);
      $('.add-cart-list--wrapper').removeClass('hide');
      const itemCountWithoutDeliveryPackaging = cart.items.filter(e => e.product_id !== 1421586137139).reduce((sum,item) => sum+= item.quantity,0);
      jQuery('.with-icon.cart-icon').find('.cart-item-count > span').html(itemCountWithoutDeliveryPackaging);
      jQuery('#CartCount').text(itemCountWithoutDeliveryPackaging);
      $('.add-cart-list--wrapper').addClass('cart--open'); 
     //  $( 'html, body' ).animate({
    	// scrollTop: $('.navbar__main-menu').offset().top
     //  }, '300' );
      setTimeout(
        function() 
        {
          $('.add-cart-list--wrapper').removeClass('cart--open'); 
        }, 5000);
    });
  }

  function updatecartprice(){
    //if added for the first time, add cart price container
    if(!jQuery('.cart-icon').find('#CartPrice').length){
      jQuery('.cart-icon').append('<div id="CartPrice" class="cart-price"><span></span></div>');
    }
    //update the price instantly
    jQuery.getJSON('/cart.js', function(cart){
      jQuery('#CartPrice').find('span').html(cart.total_price);
    });
  }

  function updateminicart(){
    jQuery.getJSON('/cart.js', function(cart){
      if(cart.item_count > 0 ){
        var html = '<ul>';                                                               
        jQuery.each(cart.items, function() {
          var _this= jQuery(this);
          var item = _this[0] ;
          html += '<li class="item-row">';
          html += '<div class="item-info-wrapper">';
          html += '<div class="prod-title">'+  item.title  + '</div>';
          html += '<div class="qty-price">';
          html += '<div class="qty">'+  item.quantity +'</div>';
          html += '<div> $ '+  item.line_price/Math.pow(10,2)  +'</div>';
          html += '</div>';
          html += '</div>';
          html += '</li>';
        });
        html += '</ul>'; 
        html += '<div class="view-cart"><a href="/cart" class="btn btn--secondary btn--small">View Cart</a>';
        html += '<div class="minicart-up"><i class="fa fa-long-arrow-up " aria-hidden="true"></i></div></div>';
        jQuery(".mini-cart").html("");
        jQuery(".mini-cart").html(html); 
      }
    });    	
  }
    /* End of add to cart ajax */

    jQuery(window).load(function(){
	//mobile search drawer positioning
 jQuery('.site-header__search-toggle.js-drawer-open-top').click(function(){
   jQuery('body #SearchDrawer').css('top','-110px');
   jQuery('body #SearchDrawer').css('height','110px');
 });
});


    $(document).ready(function(){
      var maxHeight = 0;

      $("#service-pro .grid__item").each(function(){
       if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
     });

      $("#service-pro .grid__item").height(maxHeight);




  //tab menu sidebar
  $(".sidebar-listing-inner h3").click(function() {
   if($(this).hasClass("active")) { $(this).removeClass("active"); }
   else { $(this).addClass("active"); }
 });
  
  
  $(".sidebar-category ul li").click(function() {  //use a class, since your ID gets mangled
    $(this).addClass("active");      //add the class to the clicked element
  });

});


jQuery(function(){
  initStickyBar();
  initSmoothScroll();
  initBurgerMenu();
  initSearchOpener();
  initFilterOpener();
  initCustomSelect();
  initAccordion();
});

function initAccordion() {
  $(".accordion.meal-option-list > li > .accordion__opener").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(".accordion.meal-option-list > li > .accordion__opener").removeClass("active");
      $(this).addClass("active");
    }
  });
}

//initiate Customselect
function initCustomSelect() {
  jQuery('.select-wrap select').customSelect({
    includeValue: true
  });
}

//initiate stickybar
function initStickyBar() {
  jQuery('.content, .sidebar').theiaStickySidebar({
  });
}

//initiate Mobile Menu
function initBurgerMenu() {

  //selectors
  var options = {
    pageBody: 'body',
    navActive: 'js-navigation-active',
    navOpener: '.navigation-opener',
    navDrop: '.navbar__main-menu',
    subNavOpener: '.navbar__navigation .has-dropdown > a',
    subNavDropToggle: '.navbar__navigation .has-dropdown' 
    
  };
  
  var body = jQuery(options.pageBody);
  var navOpener = body.find(options.navOpener);
  var navDrop = body.find(options.navDrop);
  var navActive = options.navActive;
  var subNavOpener = options.subNavOpener;
  var subNavDropToggle = options.subNavDropToggle;

  navOpener.on('click', function(e) {
    e.preventDefault();
    body.toggleClass(navActive);
  });

  //hide on click outside
  function hideOnClickOutSide(e) {
    var target = jQuery(e.target);
    if (!target.closest(navOpener).length && !target.closest(navDrop).length) {
      body.removeClass(navActive);
    }
  }

  //destory all
  function destroy() {
    body.on('click', function(){
      body.removeClass(navActive);
    });
  }

  body.on('click', hideOnClickOutSide);
  jQuery('.disable-nav').on('click', function(e){
    e.preventDefault();
    destroy();
  });
  
  //dropdown for mobile 
  jQuery(subNavOpener).on('click', function(e){
    e.preventDefault();
  });
  
  jQuery(subNavDropToggle).each(function() {
    jQuery(this).click(function(){
      jQuery(this).toggleClass('active');
    });
  });
}

//initiate Search Opener
function initSearchOpener() {

  //selectors
  var options = {
    pageBody: 'body',
    navActive: 'js-search-active',
    navOpener: '.search-opener',
    navDrop: '.search-popup-holder'
  };
  
  var body = jQuery(options.pageBody);
  var navOpener = body.find(options.navOpener);
  var navDrop = body.find(options.navDrop);
  var navActive = options.navActive;

  navOpener.on('click', function(e) {
    e.preventDefault();
    body.toggleClass(navActive);
  });

  //hide on click outside
  function hideOnClickOutSide(e) {
    var target = jQuery(e.target);
    if (!target.closest(navOpener).length && !target.closest(navDrop).length) {
      body.removeClass(navActive);
    }
  }

  //destory all
  function destroy() {
    body.on('click', function(){
      body.removeClass(navActive);
    });
  }

  body.on('click', hideOnClickOutSide);
  jQuery('.disable-nav').on('click', function(e){
    e.preventDefault();
    destroy();
  });
}

//initiate Filter Mobile Opener
function initFilterOpener() {

  //selectors
  var options = {
    pageBody: 'body',
    navActive: 'js-filter-active',
    navOpener: '.filter-opener',
    navDrop: '.fitler-drop'
  };
  
  var body = jQuery(options.pageBody);
  var navOpener = body.find(options.navOpener);
  var navDrop = body.find(options.navDrop);
  var navActive = options.navActive;

  navOpener.on('click', function(e) {
    e.preventDefault();
    body.toggleClass(navActive);
  });

  //hide on click outside
  function hideOnClickOutSide(e) {
    var target = jQuery(e.target);
    if (!target.closest(navOpener).length && !target.closest(navDrop).length) {
      body.removeClass(navActive);
    }
  }

  //destory all
  function destroy() {
    body.on('click', function(){
      body.removeClass(navActive);
    });
  }

  body.on('click', hideOnClickOutSide);
  jQuery('.disable-nav').on('click', function(e){
    e.preventDefault();
    destroy();
  });
}

function initSmoothScroll() {
  
  // Cache selectors
  var lastId,
      topMenu = $(".navigate-link-list, .steps-order-list"),
//       topMenuHeight = topMenu.outerHeight()+15,
      topMenuHeight = 10,
      // All list items
      menuItems = topMenu.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) { return item; }
      });

  // Bind click handler to menu items
  // so we can get a fancy scroll animation
  menuItems.click(function(e){
    var href = $(this).attr("href"),
        offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1;
    $('html, body').stop().animate({ 
        scrollTop: offsetTop
    }, 300);
    e.preventDefault();
  });

  // Bind to scroll
  $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop() + topMenuHeight;

     // Get id of current scroll item
     var cur = scrollItems.map(function(){
       if ($(this).offset().top < fromTop)
         return this;
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "";

     if (lastId !== id) {
         lastId = id;
         // Set/remove active class
         menuItems
           .parent().removeClass("active")
           .end().filter("[href='#"+id+"']").parent().addClass("active");
     }                   
  });
}

/* Custom select */
function _extends(){return(_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key])}return target}).apply(this,arguments)}var CustomSelect=function($){var defaults={block:"custom-select",hideCallback:!1,includeValue:!1,keyboard:!0,modifier:!1,placeholder:!1,search:!1,showCallback:!1,transition:0},CustomSelect=function(){function CustomSelect(select,options){this._$select=$(select),this._options=_extends({},defaults,"object"==typeof options?options:{}),this._activeModifier=this._options.block+"--active",this._dropupModifier=this._options.block+"--dropup",this._optionSelectedModifier=this._options.block+"__option--selected",this._keydown=this._keydown.bind(this),this._dropup=this._dropup.bind(this),this._outside=this._outside.bind(this),this._init()}var _proto=CustomSelect.prototype;return _proto.reset=function(){this._$dropdown.hide().empty(),this._$value.off("click"),this._fill()},_proto._init=function(){this._$element=$('<div class="'+this._options.block+'">\n           <button class="'+this._options.block+"__option "+this._options.block+'__option--value" type="button"></button>\n           <div class="'+this._options.block+'__dropdown" style="display: none;"></div>\n         </div>'),this._$select.hide().after(this._$element),this._options.modifier&&this._$element.addClass(this._options.modifier),this._$value=this._$element.find("."+this._options.block+"__option--value"),this._$dropdown=this._$element.find("."+this._options.block+"__dropdown"),this._fill()},_proto._fill=function(){var _this=this;this._$values=this._$select.find("option"),this._values=[];var placeholder=this._options.placeholder;$.each(this._$values,function(i,option){var el=$(option).text().trim();_this._values.push(el)}),placeholder&&(this._$select.find("[selected]").length?placeholder=!1:(this._$value.html(placeholder),this._$select.prop("selectedIndex",-1))),$.each(this._values,function(i,el){var cssClass=_this._$values.eq(i).attr("class"),$option=$('<button class="'+_this._options.block+'__option" type="button">'+el+"</button>"),$selected=_this._$select.find(":selected");_this._$values.eq(i).attr("disabled")&&$option.prop("disabled",!0),!$selected.length&&0===i||el===$selected.text().trim()?(placeholder||_this._$value.text(el).removeClass(_this._$value.data("class")).removeData("class").addClass(cssClass).data("class",cssClass),(_this._options.includeValue||placeholder)&&($option.addClass(cssClass),$option.toggleClass(_this._optionSelectedModifier,_this._$values.eq(i).is("[selected]")),_this._$dropdown.append($option))):($option.addClass(cssClass),_this._$dropdown.append($option))}),this._$options=this._$dropdown.find("."+this._options.block+"__option"),this._options.search&&this._search(),this._$value.one("click",function(event){_this._show(event)}),this._$value.prop("disabled",!this._$options.length),this._$options.on("click",function(event){_this._select(event)})},_proto._show=function(event){var _this2=this;event.preventDefault(),this._dropup(),$(window).on("resize scroll",this._dropup),this._$element.addClass(this._activeModifier),this._$dropdown.slideDown(this._options.transition,function(){_this2._options.search&&(_this2._$input.focus(),_this2._options.includeValue&&_this2._scroll()),"function"==typeof _this2._options.showCallback&&_this2._options.showCallback.call(_this2._$element[0])}),setTimeout(function(){$(document).on("touchstart click",_this2._outside)},0),this._$value.one("click",function(event){event.preventDefault(),_this2._hide()}),this._options.keyboard&&(this._options.index=-1,$(window).on("keydown",this._keydown))},_proto._hide=function(){var _this3=this;this._options.search&&(this._$input.val("").blur(),this._$options.show(),this._$wrap.scrollTop(0)),this._$dropdown.slideUp(this._options.transition,function(){_this3._$element.removeClass(_this3._activeModifier).removeClass(_this3._dropupModifier),"function"==typeof _this3._options.hideCallback&&_this3._options.hideCallback.call(_this3._$element[0]),_this3._$value.off("click").one("click",function(event){_this3._show(event)}),$(document).off("touchstart click",_this3._outside),$(window).off("resize scroll",_this3._dropup)}),this._options.keyboard&&(this._$options.blur(),$(window).off("keydown",this._keydown))},_proto._scroll=function(){var _this4=this;$.each(this._$options,function(i,option){var $option=$(option);if($option.text()===_this4._$value.text()){var top=$option.position().top,center=_this4._$wrap.outerHeight()/2-$option.outerHeight()/2;return center<top&&_this4._$wrap.scrollTop(top-center),!1}})},_proto._select=function(event){var _this5=this;event.preventDefault();var last,choice=$(event.currentTarget).text().trim(),values=[].concat(this._values);this._$value.text(choice).removeClass(this._$value.data("class")),this._$values.prop("selected",!1),$.each(values,function(i,el){_this5._options.includeValue||el!==choice||values.splice(i,1),$.each(_this5._$values,function(i,option){var cssClass,$option=$(option);$option.text().trim()===choice&&(cssClass=$option.attr("class"),$option.prop("selected",!0),_this5._$value.addClass(cssClass).data("class",cssClass))})}),this._hide(),this._options.includeValue?(this._$options.removeClass(this._optionSelectedModifier),$.each(this._$options,function(i,option){var $option=$(option);if($option.text().trim()===choice)return $option.addClass(_this5._optionSelectedModifier),!1})):(this._$options.length>values.length&&((last=this._$options.eq(values.length)).remove(),this._$options=this._$options.not(last),this._$options.length||this._$value.prop("disabled",!0)),$.each(this._$options,function(i,option){var $option=$(option);$option.text(values[i]),$option.attr("class",_this5._options.block+"__option"),$.each(_this5._$values,function(){var $this=$(this);$this.text().trim()===values[i]&&($option.addClass($this.attr("class")),$option.prop("disabled",$this.prop("disabled")))})})),void 0!==event.originalEvent&&this._$select.trigger("change")},_proto._search=function(){var _this6=this;this._$input=$('<input class="'+this._options.block+'__input" autocomplete="off">'),this._$dropdown.prepend(this._$input),this._$options.wrapAll('<div class="'+this._options.block+'__option-wrap"></div>'),this._$wrap=this._$element.find("."+this._options.block+"__option-wrap"),this._$input.on("focus",function(){_this6._options.index=-1}),this._$input.on("keyup",function(){var query=_this6._$input.val().trim();query.length?(_this6._$wrap.scrollTop(0),setTimeout(function(){query===_this6._$input.val().trim()&&$.each(_this6._$options,function(i,option){var $option=$(option),match=-1!==$option.text().trim().toLowerCase().indexOf(query.toLowerCase());$option.toggle(match)})},300)):_this6._$options.show()})},_proto._dropup=function(){var bottom=this._$element[0].getBoundingClientRect().bottom,up=$(window).height()-bottom<this._$dropdown.height();this._$element.toggleClass(this._dropupModifier,up)},_proto._outside=function(event){var $target=$(event.target);$target.parents().is(this._$element)||$target.is(this._$element)||this._hide()},_proto._keydown=function(event){var $option,$visible=this._$options.filter(":visible").not("[disabled]");switch(event.which){case 40:event.preventDefault(),$visible.eq(this._options.index+1).length?this._options.index+=1:this._options.index=0,$visible.eq(this._options.index).focus();break;case 38:event.preventDefault(),$visible.eq(this._options.index-1).length&&0<=this._options.index-1?--this._options.index:this._options.index=$visible.length-1,$visible.eq(this._options.index).focus();break;case 13:case 32:this._$input&&this._$input.is(":focus")||(event.preventDefault(),($option=this._$options.add(this._$value).filter(":focus")).trigger("click"),$option.is(this._$value)||this._$select.trigger("change"),this._$value.focus());break;case 27:event.preventDefault(),this._hide(),this._$value.focus()}},CustomSelect._jQueryPlugin=function(config){return this.each(function(){var $this=$(this),data=$this.data("custom-select");data?"reset"===config&&data.reset():"string"!=typeof config&&(data=new CustomSelect(this,config),$this.data("custom-select",data))})},CustomSelect}();return $.fn.customSelect=CustomSelect._jQueryPlugin,$.fn.customSelect.noConflict=function(){return $.fn.customSelect},CustomSelect}($);


//# sourceMappingURL=jquery.custom-select.min.js.map

/*!
 * Theia Sticky Sidebar v1.7.0
 * https://github.com/WeCodePixels/theia-sticky-sidebar
 *
 * Glues your website's sidebars, making them permanently visible while scrolling.
 *
 * Copyright 2013-2016 WeCodePixels and other contributors
 * Released under the MIT license
 */

(function ($) {
    $.fn.theiaStickySidebar = function (options) {
        var defaults = {
            'containerSelector': '',
            'additionalMarginTop': 0,
            'additionalMarginBottom': 0,
            'updateSidebarHeight': true,
            'minWidth': 0,
            'disableOnResponsiveLayouts': true,
            'sidebarBehavior': 'modern',
            'defaultPosition': 'relative',
            'namespace': 'TSS'
        };
        options = $.extend(defaults, options);

        // Validate options
        options.additionalMarginTop = parseInt(options.additionalMarginTop) || 0;
        options.additionalMarginBottom = parseInt(options.additionalMarginBottom) || 0;

        tryInitOrHookIntoEvents(options, this);

        // Try doing init, otherwise hook into window.resize and document.scroll and try again then.
        function tryInitOrHookIntoEvents(options, $that) {
            var success = tryInit(options, $that);

            if (!success) {
                console.log('TSS: Body width smaller than options.minWidth. Init is delayed.');

                $(document).on('scroll.' + options.namespace, function (options, $that) {
                    return function (evt) {
                        var success = tryInit(options, $that);

                        if (success) {
                            $(this).unbind(evt);
                        }
                    };
                }(options, $that));
                $(window).on('resize.' + options.namespace, function (options, $that) {
                    return function (evt) {
                        var success = tryInit(options, $that);

                        if (success) {
                            $(this).unbind(evt);
                        }
                    };
                }(options, $that))
            }
        }

        // Try doing init if proper conditions are met.
        function tryInit(options, $that) {
            if (options.initialized === true) {
                return true;
            }

            if ($('body').width() < options.minWidth) {
                return false;
            }

            init(options, $that);

            return true;
        }

        // Init the sticky sidebar(s).
        function init(options, $that) {
            options.initialized = true;

            // Add CSS
            var existingStylesheet = $('#theia-sticky-sidebar-stylesheet-' + options.namespace);
            if (existingStylesheet.length === 0) {
                $('head').append($('<style id="theia-sticky-sidebar-stylesheet-' + options.namespace + '">.theiaStickySidebar:after {content: ""; display: table; clear: both;}</style>'));
            }

            $that.each(function () {
                var o = {};

                o.sidebar = $(this);

                // Save options
                o.options = options || {};

                // Get container
                o.container = $(o.options.containerSelector);
                if (o.container.length == 0) {
                    o.container = o.sidebar.parent();
                }

                // Create sticky sidebar
                o.sidebar.parents().css('-webkit-transform', 'none'); // Fix for WebKit bug - https://code.google.com/p/chromium/issues/detail?id=20574
                o.sidebar.css({
                    'position': o.options.defaultPosition,
                    'overflow': 'visible',
                    // The "box-sizing" must be set to "content-box" because we set a fixed height to this element when the sticky sidebar has a fixed position.
                    '-webkit-box-sizing': 'border-box',
                    '-moz-box-sizing': 'border-box',
                    'box-sizing': 'border-box'
                });

                // Get the sticky sidebar element. If none has been found, then create one.
                o.stickySidebar = o.sidebar.find('.theiaStickySidebar');
                if (o.stickySidebar.length == 0) {
                    // Remove <script> tags, otherwise they will be run again when added to the stickySidebar.
                    var javaScriptMIMETypes = /(?:text|application)\/(?:x-)?(?:javascript|ecmascript)/i;
                    o.sidebar.find('script').filter(function (index, script) {
                        return script.type.length === 0 || script.type.match(javaScriptMIMETypes);
                    }).remove();

                    o.stickySidebar = $('<div>').addClass('theiaStickySidebar').append(o.sidebar.children());
                    o.sidebar.append(o.stickySidebar);
                }

                // Get existing top and bottom margins and paddings
                o.marginBottom = parseInt(o.sidebar.css('margin-bottom'));
                o.paddingTop = parseInt(o.sidebar.css('padding-top'));
                o.paddingBottom = parseInt(o.sidebar.css('padding-bottom'));

                // Add a temporary padding rule to check for collapsable margins.
                var collapsedTopHeight = o.stickySidebar.offset().top;
                var collapsedBottomHeight = o.stickySidebar.outerHeight();
                o.stickySidebar.css('padding-top', 1);
                o.stickySidebar.css('padding-bottom', 1);
                collapsedTopHeight -= o.stickySidebar.offset().top;
                collapsedBottomHeight = o.stickySidebar.outerHeight() - collapsedBottomHeight - collapsedTopHeight;
                if (collapsedTopHeight == 0) {
                    o.stickySidebar.css('padding-top', 0);
                    o.stickySidebarPaddingTop = 0;
                }
                else {
                    o.stickySidebarPaddingTop = 1;
                }

                if (collapsedBottomHeight == 0) {
                    o.stickySidebar.css('padding-bottom', 0);
                    o.stickySidebarPaddingBottom = 0;
                }
                else {
                    o.stickySidebarPaddingBottom = 1;
                }

                // We use this to know whether the user is scrolling up or down.
                o.previousScrollTop = null;

                // Scroll top (value) when the sidebar has fixed position.
                o.fixedScrollTop = 0;

                // Set sidebar to default values.
                resetSidebar();

                o.onScroll = function (o) {
                    // Stop if the sidebar isn't visible.
                    if (!o.stickySidebar.is(":visible")) {
                        return;
                    }

                    // Stop if the window is too small.
                    if ($('body').width() < o.options.minWidth) {
                        resetSidebar();
                        return;
                    }

                    // Stop if the sidebar width is larger than the container width (e.g. the theme is responsive and the sidebar is now below the content)
                    if (o.options.disableOnResponsiveLayouts) {
                        var sidebarWidth = o.sidebar.outerWidth(o.sidebar.css('float') == 'none');

                        if (sidebarWidth + 50 > o.container.width()) {
                            resetSidebar();
                            return;
                        }
                    }

                    var scrollTop = $(document).scrollTop();
                    var position = 'static';

                    // If the user has scrolled down enough for the sidebar to be clipped at the top, then we can consider changing its position.
                    if (scrollTop >= o.sidebar.offset().top + (o.paddingTop - o.options.additionalMarginTop)) {
                        // The top and bottom offsets, used in various calculations.
                        var offsetTop = o.paddingTop + options.additionalMarginTop;
                        var offsetBottom = o.paddingBottom + o.marginBottom + options.additionalMarginBottom;

                        // All top and bottom positions are relative to the window, not to the parent elemnts.
                        var containerTop = o.sidebar.offset().top;
                        var containerBottom = o.sidebar.offset().top + getClearedHeight(o.container);

                        // The top and bottom offsets relative to the window screen top (zero) and bottom (window height).
                        var windowOffsetTop = 0 + options.additionalMarginTop;
                        var windowOffsetBottom;

                        var sidebarSmallerThanWindow = (o.stickySidebar.outerHeight() + offsetTop + offsetBottom) < $(window).height();
                        if (sidebarSmallerThanWindow) {
                            windowOffsetBottom = windowOffsetTop + o.stickySidebar.outerHeight();
                        }
                        else {
                            windowOffsetBottom = $(window).height() - o.marginBottom - o.paddingBottom - options.additionalMarginBottom;
                        }

                        var staticLimitTop = containerTop - scrollTop + o.paddingTop;
                        var staticLimitBottom = containerBottom - scrollTop - o.paddingBottom - o.marginBottom;

                        var top = o.stickySidebar.offset().top - scrollTop;
                        var scrollTopDiff = o.previousScrollTop - scrollTop;

                        // If the sidebar position is fixed, then it won't move up or down by itself. So, we manually adjust the top coordinate.
                        if (o.stickySidebar.css('position') == 'fixed') {
                            if (o.options.sidebarBehavior == 'modern') {
                                top += scrollTopDiff;
                            }
                        }

                        if (o.options.sidebarBehavior == 'stick-to-top') {
                            top = options.additionalMarginTop;
                        }

                        if (o.options.sidebarBehavior == 'stick-to-bottom') {
                            top = windowOffsetBottom - o.stickySidebar.outerHeight();
                        }

                        if (scrollTopDiff > 0) { // If the user is scrolling up.
                            top = Math.min(top, windowOffsetTop);
                        }
                        else { // If the user is scrolling down.
                            top = Math.max(top, windowOffsetBottom - o.stickySidebar.outerHeight());
                        }

                        top = Math.max(top, staticLimitTop);

                        top = Math.min(top, staticLimitBottom - o.stickySidebar.outerHeight());

                        // If the sidebar is the same height as the container, we won't use fixed positioning.
                        var sidebarSameHeightAsContainer = o.container.height() == o.stickySidebar.outerHeight();

                        if (!sidebarSameHeightAsContainer && top == windowOffsetTop) {
                            position = 'fixed';
                        }
                        else if (!sidebarSameHeightAsContainer && top == windowOffsetBottom - o.stickySidebar.outerHeight()) {
                            position = 'fixed';
                        }
                        else if (scrollTop + top - o.sidebar.offset().top - o.paddingTop <= options.additionalMarginTop) {
                            // Stuck to the top of the page. No special behavior.
                            position = 'static';
                        }
                        else {
                            // Stuck to the bottom of the page.
                            position = 'absolute';
                        }
                    }

                    /*
                     * Performance notice: It's OK to set these CSS values at each resize/scroll, even if they don't change.
                     * It's way slower to first check if the values have changed.
                     */
                    if (position == 'fixed') {
                        var scrollLeft = $(document).scrollLeft();

                        o.stickySidebar.css({
                            'position': 'fixed',
                            'width': getWidthForObject(o.stickySidebar) + 'px',
                            'transform': 'translateY(' + top + 'px)',
                            'left': (o.sidebar.offset().left + parseInt(o.sidebar.css('padding-left')) - scrollLeft) + 'px',
                            'top': '0px'
                        });
                    }
                    else if (position == 'absolute') {
                        var css = {};

                        if (o.stickySidebar.css('position') != 'absolute') {
                            css.position = 'absolute';
                            css.transform = 'translateY(' + (scrollTop + top - o.sidebar.offset().top - o.stickySidebarPaddingTop - o.stickySidebarPaddingBottom) + 'px)';
                            css.top = '0px';
                        }

                        css.width = getWidthForObject(o.stickySidebar) + 'px';
                        css.left = '';

                        o.stickySidebar.css(css);
                    }
                    else if (position == 'static') {
                        resetSidebar();
                    }

                    if (position != 'static') {
                        if (o.options.updateSidebarHeight == true) {
                            o.sidebar.css({
                                'min-height': o.stickySidebar.outerHeight() + o.stickySidebar.offset().top - o.sidebar.offset().top + o.paddingBottom
                            });
                        }
                    }

                    o.previousScrollTop = scrollTop;
                };

                // Initialize the sidebar's position.
                o.onScroll(o);

                // Recalculate the sidebar's position on every scroll and resize.
                $(document).on('scroll.' + o.options.namespace, function (o) {
                    return function () {
                        o.onScroll(o);
                    };
                }(o));
                $(window).on('resize.' + o.options.namespace, function (o) {
                    return function () {
                        o.stickySidebar.css({'position': 'static'});
                        o.onScroll(o);
                    };
                }(o));

                // Recalculate the sidebar's position every time the sidebar changes its size.
                if (typeof ResizeSensor !== 'undefined') {
                    new ResizeSensor(o.stickySidebar[0], function (o) {
                        return function () {
                            o.onScroll(o);
                        };
                    }(o));
                }

                // Reset the sidebar to its default state
                function resetSidebar() {
                    o.fixedScrollTop = 0;
                    o.sidebar.css({
                        'min-height': '1px'
                    });
                    o.stickySidebar.css({
                        'position': 'static',
                        'width': '',
                        'transform': 'none'
                    });
                }

                // Get the height of a div as if its floated children were cleared. Note that this function fails if the floats are more than one level deep.
                function getClearedHeight(e) {
                    var height = e.height();

                    e.children().each(function () {
                        height = Math.max(height, $(this).height());
                    });

                    return height;
                }
            });
        }

        function getWidthForObject(object) {
            var width;

            try {
                width = object[0].getBoundingClientRect().width;
            }
            catch (err) {
            }

            if (typeof width === "undefined") {
                width = object.width();
            }

            return width;
        }

        return this;
    }
})(jQuery);

//# sourceMappingURL=maps/theia-sticky-sidebar.js.map
$(document).ready(function(){
  $('.show-all-past-orders').click(function(){
	$(this).prev('.past-order').find('tr').removeClass('hide');
    $(this).remove();
  });
});

// For Multiple Tags Filter in Collection page
function mutlitagsfilters(x, filterToToggle = false)
      {
        var diet =x +"/";
        var count = 0;
	
		$('input[name="diet"]').each(function(){
  		if (this.checked)
    	{
          if(filterToToggle != this.id){
      		diet += this.id;
          	count+=1;
          }
    	}
		});
        $('input[name="ingredients"]').each(function(){
  		if (this.checked)
    	{
          if(filterToToggle != this.id){
            if(count>0){diet += "+"}
            diet += this.id; 	
          }
    	}
		});
        window.location="https://goodmeal.com.au/collections/"+ diet;
      }